import React from "react";
import { Button, type ButtonProps } from "./ui/button";
import NextLink from "next/link";
import { cn } from "@/lib/utils";
import { UrlObject } from "url";

export interface LinkProps extends ButtonProps {
  header?: boolean;
  href: string | UrlObject;
  passHref?: boolean;
  children: React.ReactNode;
  locale?: string;
  prefetch?: boolean;
  title?: string;
}

export const Link: React.FC<LinkProps> = ({
  header = false,
  href,
  children,
  variant,
  passHref,
  className,
  prefetch,
  title,
  ...props
}) => {
  return (
    <Button
      variant={variant ?? "link"}
      className={cn(
        {
          "hover:underline": !header && (variant ?? "link") == "link",
        },
        className
      )}
      asChild
      {...props}
    >
      <NextLink
        href={href}
        passHref={passHref}
        prefetch={prefetch}
        title={title}
      >
        {children}
      </NextLink>
    </Button>
  );
};
